import { render } from "./SidebarNavigation.vue?vue&type=template&id=583faee2&ts=true"
import script from "./SidebarNavigation.vue?vue&type=script&lang=ts"
export * from "./SidebarNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__